import { useRouter } from 'next/router'
import { Language } from 'types/language'
import styles from './Terms.module.scss'
import { TermsProps } from 'features/terms/types'

const Terms = ({ content }: TermsProps) => {
  // Next router
  const { locale } = useRouter()

  return <section className={styles.terms}>{content[locale as Language]}</section>
}

export default Terms
